import { useQuery } from '@tanstack/react-query';
import { InquiryBidvVAEntity, BidvVirtualAccountService, InquiryBidvVADto } from 'services/openapi';

import { BidvVirtualAccountServiceQueryKeys } from '../constants';

type InquiryBidvVAQueryDTO = {
  endCode: string;
  requestBody: InquiryBidvVADto;
  enabled?: boolean;
};

export const useInquiryBidvVAQuery = (variables: InquiryBidvVAQueryDTO) => {
  const { enabled = true, endCode, requestBody } = variables;
  const queryKey = [BidvVirtualAccountServiceQueryKeys.INQUIRY, endCode, requestBody];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<InquiryBidvVAEntity, Error>({
    queryKey,
    queryFn: () =>
      BidvVirtualAccountService.bidvVaControllerInquiry(endCode, requestBody),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: enabled && !!endCode && !!requestBody,
  });

  return {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  };
};